var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4056",
    "data-name": "Rectangle 4056",
    width: 19.838,
    height: 14.395,
    fill: "#597931"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10896",
    "data-name": "Group 10896",
    transform: "translate(-1714.869 -949.869)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9577",
    "data-name": "Group 9577",
    transform: "translate(1715.001 950)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_241",
    "data-name": "Ellipse 241",
    transform: "translate(-0.132 -0.131)",
    fill: "#fff",
    stroke: "#597931",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9820",
    "data-name": "Group 9820",
    transform: "translate(1727.534 965.256)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9705",
    "data-name": "Group 9705",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33409",
    "data-name": "Path 33409",
    d: "M16.685,8.082h-.251q-7.679,0-15.359,0a1.663,1.663,0,0,1-.418-.035.893.893,0,0,1,.2-1.753c.084,0,.169,0,.253,0H16.694l.075-.1a.749.749,0,0,1-.207-.1q-2.26-2.248-4.513-4.5A.9.9,0,0,1,13.2.2a2.154,2.154,0,0,1,.169.159l6.095,6.085a.92.92,0,0,1,0,1.481q-3.07,3.065-6.139,6.131a.929.929,0,0,1-.951.306.9.9,0,0,1-.448-1.45c.05-.059.107-.112.162-.166q2.233-2.229,4.467-4.457a1.219,1.219,0,0,1,.189-.129l-.061-.077",
    transform: "translate(0 0.001)",
    fill: "#597931"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right_arrow.cd08fe2ab0253341d643721dc3919ed1.svg";
export { ForwardRef as ReactComponent };